<div class="panel">
  <h2>{{ title }}</h2>

  <div class="btn-toolbar">

    <a class="btn btn-small btn-gray" title="Ajouter une autorisation" (click)="add($event)">
      <t-icon name="add"></t-icon>
      <span class="text">Ajouter</span>
    </a>

  </div>

  <table>

    <thead *ngIf="authorizations && authorizations.length > 0">
      <tr>
        <th>
          <ng-container *ngIf="account">Entité</ng-container>
          <ng-container *ngIf="entity">Compte client</ng-container>
        </th>
        <th style="width: 50px;"></th>
      </tr>
    </thead>

    <tbody *ngIf="authorizations && authorizations.length > 0">
      <tr *ngFor="let authorization of authorizations" (click)="showItem(authorization, $event)">
        <td *ngIf="account" name="Entité">{{ authorization.entity.name }}</td>
        <td *ngIf="entity" name="Compte client">{{ authorization.account.name }}</td>

        <td style="width: 50px;" class="actions">
          <a class="action-btn" title="Supprimer" (click)="delete(authorization)">
            <t-icon name="delete"></t-icon>
          </a>
        </td>
      </tr>
    </tbody>

  </table>

  <div class="empty-table compact" *ngIf="!authorizations || authorizations.length == 0">
    <p>
      <ng-container *ngIf="authorizations && authorizations.length == 0">
        Aucune autorisation trouvée
      </ng-container>
      <ng-container *ngIf="!authorizations">
        Chargement...
      </ng-container>
    </p>
  </div>

</div>
